export function makeArrayFromEnum<T extends object>(
  params: T,
): { label: string; value: T[keyof T] }[] {
  return Object.keys(params)
    .filter((key) => isNaN(Number(key)))
    .map((el) => {
      return {
        label: el,
        value: params[el as keyof typeof params],
      };
    });
}
